"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class OMParty extends __1.OMObject {
}
OMParty.Type = "party";
OMParty.Path = "parties";
exports.default = OMParty;
//# sourceMappingURL=OMParty.js.map